import { PredefinedDashboard } from '../widgetDashboard.enums'
import { WidgetDashboardConfig } from '../widgetDashboard.interface'
import DashboardWrapper from './DashboardWrapper'

export class Layout_h2_2v3 extends DashboardWrapper {
    constructor() {
        super(PredefinedDashboard.LAYOUT_H2_2V3)
        this.dashboardConfig = {
            name: 'Untitled',
            panes: {
                id: 1,
                space: 100,
                horizontal: true,
                panes: [{
                    id: 2,
                    space: 50,
                    horizontal: true,
                    panes: []
                }, {
                    id: 3,
                    space: 50,
                    horizontal: false,
                    panes: [{
                        id: 4,
                        space: 33.33,
                        horizontal: true,
                        panes: []
                    }, {
                        id: 5,
                        space: 33.33,
                        horizontal: true,
                        panes: []
                    }, {
                        id: 6,
                        space: 33.33,
                        horizontal: true,
                        panes: []
                    }]
                }]
            },
            singleMode: false,
            widgets: {},
            syncSettings: {
                security: false,
                crosshair: false,
                time: false,
                timeBucket: false,
                drawing: false
            }
        } as WidgetDashboardConfig
    }

}